// extracted by mini-css-extract-plugin
export default {"title":"LinedDecorTitle_title__Va57K"};